module.exports = __webpack_public_path__ + "static/media/teamwork.9e56e4e5.jpg";